import type { FC } from 'react'
import { PopoverContext } from './utils/usePopoverContext'
import { usePopover } from './utils/usePopover'
import type { PopoverProviderProps } from './types'

export const PopoverProvider: FC<PopoverProviderProps> = ({
  children,
  ...options
}) => {
  const popover = usePopover(options)

  return (
    <PopoverContext.Provider value={popover}>
      {children}
    </PopoverContext.Provider>
  )
}
